import { useState } from "react";

const faqs = [
  {
    q: "I'm not based in the EU. Does this apply?",
    a: "Yes. If any of your users are in the EU, Article 50 applies to you — regardless of where your company is based.",
  },
  {
    q: "My product uses OpenAI / Claude. Am I the \"provider\"?",
    a: "For the model, no — but when you wrap it into a chatbot you ship under your own name, you become the provider of that interactive system. The \"you're talking to an AI\" disclosure (Art. 50.1) is on you. Our report tells you exactly which paragraphs apply.",
  },
  {
    q: "How does this scale across a large product portfolio?",
    a: "One assessment run covers your entire platform under a single dashboard, with each finding traceable to its source clause. Legal, compliance, and engineering work from the same auditable report.",
  },
  {
    q: "Is this the same as a GDPR cookie banner?",
    a: "Different law, similar principle. You need a disclosure when AI interacts with users — not a consent banner. Simpler than GDPR.",
  },
  {
    q: "What if my AI feature is minimal — a spelling checker or basic sort?",
    a: "Article 50 targets chatbots, generative AI, and emotion recognition. Minimal AI is likely out of scope. Our scan will tell you.",
  },
  {
    q: "Is this legal advice? Do I need a lawyer instead?",
    a: "It's a practical compliance assessment built directly on the official Article 50 text — implementation guidance, not formal legal advice. Where your case sits in a genuine gray area, we say so and tell you when legal review is actually worth it.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="section-head">
          <p className="eyebrow">
            <i className="ri-question-answer-line" />
            FAQ
          </p>
          <h2 className="section-title">
            Questions we hear every week
          </h2>
          <p className="section-lede">
            If yours isn't here, the answer usually is — ask in the form below.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className={`border rounded-lg transition-all duration-200 ${
                  isOpen ? "border-primary-300/60 bg-background-50 shadow-sm" : "border-background-200/70 bg-background-50"
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.q}
                  </span>
                  <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-200">
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line`} />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}